import axios from 'axios';
import {Message} from 'iview';
import router from "../router"
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
});
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data) {
      if (response.data.Code == 0) {
        return response.data.Data;
      } else if (response.data.Code == 100) {
        router.push('/login')
        return;
      } else {
        Message.info(response.data.Message);
        return Promise.reject(response.data);
      }
    }
    return response;
  },
  error => {
    Message.info('网络开了小差~');
    return Promise.reject(error.response)
  });



// WEBPACK FOOTER //
// ./src/service/config.js